<template>
  <div id="app" class="main">
    <div class="content">
      <router-view />
    </div>
    <div class="weChat-wrapper">
      <we-chat />
    </div>
    <new-user-tutorials-comp />
    <div class="bottom-footer">
      <singleron-footer-comp v-if="!$route.meta.hideFooter" />
    </div>
    
  </div>
</template>
<script>
import SingleronFooterComp from "@/views/production/footer";
import { isCNSite } from "@/utils";
import weChat from "@/components/weChat";
import Tutorials from "@/components/Tutorials";
export default {
  name: 'App',
  components: {
    SingleronFooterComp,
    weChat,
    "new-user-tutorials-comp": Tutorials,
  },
  async created(){
    this.setI18nLanguage();
  },
  methods:{
    setI18nLanguage() {
      const defaultLang = isCNSite() ?  'zh-CN' : 'en-US';
      document.querySelector('html').setAttribute('lang', defaultLang);
    },
  },
};
</script>
<style lang="scss" scoped>


.main {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1 0 100vh; // 940
}
.bottom-footer {
  flex: 0;
}
</style>
